import { Alert, Checkbox, Col, Form, List, message, Popconfirm, Row } from 'antd';
import { getAuthStore } from 'core/modules/auth/auth.store';
import { getTaskStore } from 'core/modules/tasks/task.store';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { DateFromNow } from '../DateFromNow';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/** This component shows information about the version of the task. */
export var TaskVersioning = function TaskVersioning(_ref) {
  var task = _ref.task;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getAuthStore = getAuthStore(),
      canManageFinances = _getAuthStore.canManageFinances;

  var _getTaskStore = getTaskStore(),
      setTaskVersionInvoiceCollected = _getTaskStore.setTaskVersionInvoiceCollected;

  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        span: 8,
        children: /*#__PURE__*/_jsxs(Form.Item, {
          label: t('task.version'),
          children: ["#", task.version + 1]
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 16,
        children: task.version > 0 && /*#__PURE__*/_jsx(Alert, {
          message: t('task.reopen'),
          type: "info",
          showIcon: true
        })
      })]
    }), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        span: 8,
        children: /*#__PURE__*/_jsx(Form.Item, {
          label: t('task.createdAt'),
          children: /*#__PURE__*/_jsx(DateFromNow, {
            date: task.createdAt
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 8,
        children: /*#__PURE__*/_jsx(Form.Item, {
          label: t('task.updatedAt'),
          children: /*#__PURE__*/_jsx(DateFromNow, {
            date: task.updatedAt
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 8,
        children: /*#__PURE__*/_jsx(Form.Item, {
          label: t('task.closedAt'),
          children: /*#__PURE__*/_jsx(DateFromNow, {
            date: task.closedAt
          })
        })
      })]
    }), canManageFinances && /*#__PURE__*/_jsx(Form.Item, {
      label: t('task.invoices'),
      children: /*#__PURE__*/_jsx(List, {
        children: task.versions.map(function (version, index) {
          return /*#__PURE__*/_jsxs(List.Item, {
            className: "invoices-version",
            children: [/*#__PURE__*/_jsx("span", {
              className: "version",
              children: t('task.versionNumber', {
                version: version.version + 1
              })
            }), /*#__PURE__*/_jsx(Popconfirm, {
              getPopupContainer: function getPopupContainer(trigger) {
                return trigger.parentElement;
              },
              title: version.invoice.collected ? t('task.versions.invoice.confirmUncheck', {
                version: "#".concat(version.version + 1)
              }) : t('task.versions.invoice.confirmCheck', {
                version: "#".concat(version.version + 1)
              }),
              cancelText: t('no'),
              okText: t('yes'),
              onConfirm: function onConfirm() {
                setTaskVersionInvoiceCollected(task, version.version, !version.invoice.collected)["catch"](function () {
                  message.error(t('unknownError'));
                });
              },
              children: /*#__PURE__*/_jsx(Checkbox, {
                checked: version.invoice.collected,
                children: version.invoice.collected ? t('task.versions.invoice.collected') : t('task.versions.invoice.pending')
              })
            })]
          }, index);
        })
      })
    })]
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "Versioning__Container",
  componentId: "sc-gn9rc9-0"
})([".invoices-version{label > span:last-child{width:90px;text-align:right;}}"]);